import { render, staticRenderFns } from "./CTypeField.vue?vue&type=template&id=3bed9f40"
import script from "./CTypeField.vue?vue&type=script&lang=ts"
export * from "./CTypeField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports